export default {
  deliveryTitle: {
    id: 'funnel_address_confirmation_page_delivery_method_title',
    defaultMessage: 'Select delivery method',
  },
}
